import '../../App.css';
import Header from '../header';

function BlogBonnet() {
  return (
    <div className="App">
      <Header pos={''} blend={'normal'} />
      <div className="blog-container">

        <h1 className="blog-title">
          How to knit the bonnet of your dreams
        </h1>
        <h3>
          A freehand guide
        </h3>
        <p className="blog-meta">November 25, 2025 ✿ Reading time: 5 minutes</p>


        <p>
          <br></br>

          <p id="left">
          </p>
        </p>
      </div>
    </div>
  );
}

export default BlogBonnet;